




































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import spacetime, {Spacetime} from "spacetime";
import {jobDescriptionOptions} from "@/util/jobDescriptionOptions";

type BasicTaxDetails = {
    firstName: string;
    lastName: string;
    dob?: string;
    jobDescription?: string;
    countryName?: string;
    postCode?: string;
    address?: string;
    mobileNumber?: string;
    niNumber?: string;
    utrNumber?: string;
    dateBeganSelfEmployment?: string;
    dateCeasedSelfEmployment?: string;
}

@Component
export default class BasicTaxDetailsForm extends Vue {

    @Prop()
    taxDetailsProp!: BasicTaxDetails;

    @Prop()
    taxYear!: number;

    private jobOptions = jobDescriptionOptions;

    private taxDetails: BasicTaxDetails = this.taxDetailsProp;
    private otherJobDescription: string | null = null;

    private loading: boolean = false;

    private dob: Spacetime | null = this.taxDetails.dob ? spacetime(this.taxDetails.dob) : null;
    private dateBeganSelfEmployment: Spacetime | null = this.taxDetails.dateBeganSelfEmployment ? spacetime(this.taxDetails.dateBeganSelfEmployment) : null;
    private dateCeasedSelfEmployment: Spacetime | null = this.taxDetails.dateCeasedSelfEmployment ? spacetime(this.taxDetails.dateCeasedSelfEmployment) : null;

    private isStillSelfEmployed: boolean = this.dateCeasedSelfEmployment === null;

    private mounted() {
        if (this.taxDetails.jobDescription) {
            if (!this.jobOptions.find((option) => option === this.taxDetails.jobDescription)) {
                this.otherJobDescription = this.taxDetails.jobDescription;
                this.taxDetails.jobDescription = 'Other';
            }
        }
    }

    @Watch('isStillSelfEmployed')
    private onIsStillSelfEmployedChanged(stillSelfEmployed: boolean) {
        if (stillSelfEmployed) {
            this.dateCeasedSelfEmployment = null;
        }
    }
}
